import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import OrderPrepareGif from "../../../../assets/images/order_prepare.gif";
const OrderSuccessModal = ({ orderNumber, handleModal }: any) => {
  const navigate = useNavigate();
  return (
    <div className='modal'>
      <div
        className='modal-background'
        onClick={() => navigate("/")}
      ></div>
      <div className='modal-content'>
        <div className='box'>
          <div className='flex border-b'>
            <div className='flex-1 font-bold p-4'>سفارش موفق</div>
            <div>
              <button
                onClick={() => navigate("/")}
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div>
            <img
              src={OrderPrepareGif}
              className='block'
              style={{ width: "360px" }}
              alt={"OrderPrepareGif"}
            />
          </div>
          <div className='font-bold text-center text-xl my-2'>
            <span className='bg-green-100 text-green-900 rounded px-2'>{`#${orderNumber}`}</span>
          </div>
          <div className='p-2'>سفارش شما با موفقیت ثبت شد</div>

          <div className='p-2 border-t flex'>
            <div className='flex-1'>
              <button
                className='px-4 py-2 rounded w-full font-bold bg-rose-900 text-white'
                onClick={() => navigate("/profile/orders")}
              >
                پیگیری سفارش
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderSuccessModal;
